// CMAM - TOF ERDA
import {
  createCMAMTOFERDAFile,
  listCMAMTOFERDAFilesByProposal,
  fetchCMAMTOFERDAFiles,
  updateCMAMTOFERDAFile,
  softDeleteCMAMTOFERDAFile,
} from "./CMAMTOFERDAFileApi";

// CNA-STD - ERDA
import {
  createCNASTDERDAFile,
  fetchCNASTDERDAFiles,
  listCNASTDERDAFilesByProposal,
  updateCNASTDERDAFile,
  softDeleteCNASTDERDAFile,
} from "./CNASTDERDAFileApi";

// CNA-STD - NRA
import {
  createCNASTDNRAFile,
  fetchCNASTDNRAFiles,
  listCNASTDNRAFilesByProposal,
  updateCNASTDNRAFile,
  softDeleteCNASTDNRAFile,
} from "./CNASTDNRAFileApi";

// CNA-STD - PIGE
import {
  createCNASTDPIGEFile,
  fetchCNASTDPIGEFiles,
  listCNASTDPIGEFilesByProposal,
  updateCNASTDPIGEFile,
  softDeleteCNASTDPIGEFile,
} from "./CNASTDPIGEFileApi";

// CNA-STD - PIXE
import {
  createCNASTDPIXEFile,
  fetchCNASTDPIXEFiles,
  listCNASTDPIXEFilesByProposal,
  updateCNASTDPIXEFile,
  softDeleteCNASTDPIXEFile,
} from "./CNASTDPIXEFileApi";

// CNA-STD - RBS
import {
  createCNASTDRBSFile,
  fetchCNASTDRBSFiles,
  listCNASTDRBSFilesByProposal,
  updateCNASTDRBSFile,
  softDeleteCNASTDRBSFile,
} from "./CNASTDRBSFileApi";

// CNA-uB - IBIC
import {
  createCNAuBIBICFile,
  fetchCNAuBIBICFiles,
  listCNAuBIBICFilesByProposal,
  updateCNAuBIBICFile,
  softDeleteCNAuBIBICFile,
} from "./CNAuBIBICFileApi";

// CNA-uB - PIXE
import {
  createCNAuBPIXEFile,
  fetchCNAuBPIXEFiles,
  listCNAuBPIXEFilesByProposal,
  updateCNAuBPIXEFile,
  softDeleteCNAuBPIXEFile,
} from "./CNAuBPIXEFileApi";

// CNA-uB - TRIBIC
import {
  createCNAuBTRIBICFile,
  fetchCNAuBTRIBICFiles,
  listCNAuBTRIBICFilesByProposal,
  updateCNAuBTRIBICFile,
  softDeleteCNAuBTRIBICFile,
} from "./CNAuBTRIBICFileApi";

// ===============================
// Registro de funciones por modelKey
// ===============================

export const fileCreateByModelKey = {
  cmam_toferda_files: createCMAMTOFERDAFile,
  cna_std_erda_files: createCNASTDERDAFile,
  cna_std_nra_files: createCNASTDNRAFile,
  cna_std_pige_files: createCNASTDPIGEFile,
  cna_std_pixe_files: createCNASTDPIXEFile,
  cna_std_rbs_files: createCNASTDRBSFile,
  cna_ub_ibic_files: createCNAuBIBICFile,
  cna_ub_pixe_files: createCNAuBPIXEFile,
  cna_ub_tribic_files: createCNAuBTRIBICFile,
};

export const fileFetchByModelKey = {
  cmam_toferda_files: fetchCMAMTOFERDAFiles,
  cna_std_erda_files: fetchCNASTDERDAFiles,
  cna_std_nra_files: fetchCNASTDNRAFiles,
  cna_std_pige_files: fetchCNASTDPIGEFiles,
  cna_std_pixe_files: fetchCNASTDPIXEFiles,
  cna_std_rbs_files: fetchCNASTDRBSFiles,
  cna_ub_ibic_files: fetchCNAuBIBICFiles,
  cna_ub_pixe_files: fetchCNAuBPIXEFiles,
  cna_ub_tribic_files: fetchCNAuBTRIBICFiles,
};

export const fileUpdateByModelKey = {
  cmam_toferda_files: updateCMAMTOFERDAFile,
  cna_std_erda_files: updateCNASTDERDAFile,
  cna_std_nra_files: updateCNASTDNRAFile,
  cna_std_pige_files: updateCNASTDPIGEFile,
  cna_std_pixe_files: updateCNASTDPIXEFile,
  cna_std_rbs_files: updateCNASTDRBSFile,
  cna_ub_ibic_files: updateCNAuBIBICFile,
  cna_ub_pixe_files: updateCNAuBPIXEFile,
  cna_ub_tribic_files: updateCNAuBTRIBICFile,
};

export const fileSoftDeleteByModelKey = {
  cmam_toferda_files: softDeleteCMAMTOFERDAFile,
  cna_std_erda_files: softDeleteCNASTDERDAFile,
  cna_std_nra_files: softDeleteCNASTDNRAFile,
  cna_std_pige_files: softDeleteCNASTDPIGEFile,
  cna_std_pixe_files: softDeleteCNASTDPIXEFile,
  cna_std_rbs_files: softDeleteCNASTDRBSFile,
  cna_ub_ibic_files: softDeleteCNAuBIBICFile,
  cna_ub_pixe_files: softDeleteCNAuBPIXEFile,
  cna_ub_tribic_files: softDeleteCNAuBTRIBICFile,
};

export const fileListByModelKeyAndProposal = {
  cmam_toferda_files: listCMAMTOFERDAFilesByProposal,
  cna_std_erda_files: listCNASTDERDAFilesByProposal,
  cna_std_nra_files: listCNASTDNRAFilesByProposal,
  cna_std_pige_files: listCNASTDPIGEFilesByProposal,
  cna_std_pixe_files: listCNASTDPIXEFilesByProposal,
  cna_std_rbs_files: listCNASTDRBSFilesByProposal,
  cna_ub_ibic_files: listCNAuBIBICFilesByProposal,
  cna_ub_pixe_files: listCNAuBPIXEFilesByProposal,
  cna_ub_tribic_files: listCNAuBTRIBICFilesByProposal,
};
